import { render } from "./App.vue?vue&type=template&id=14dd1843"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=14dd1843&lang=css"

import exportComponent from "/Users/rydercook/Documents/Project Development/Award Slider/awardslider/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__